const $ = require('jquery');
const moment = require('moment');
require('moment/locale/de');

window.$ = $;
window.jQuery = $;
window.moment = moment;

require('daterangepicker/daterangepicker.js');
